"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureGetErrorMessage = exports.configureGetErrorTitle = exports.getTranslatedErrorMessage = exports.getTranslatedErrorTitle = exports.getTranslatedErrorText = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var sentryLogger = function sentryLogger(sentryData) {
  var _sentryData$errorType = sentryData.errorType,
      errorType = _sentryData$errorType === void 0 ? 'MISSING ERROR TYPE' : _sentryData$errorType,
      _sentryData$message = sentryData.message,
      message = _sentryData$message === void 0 ? '' : _sentryData$message,
      status = sentryData.status,
      prefixKey = sentryData.prefixKey,
      messageType = sentryData.messageType,
      missingKeys = sentryData.missingKeys;

  if (window.Raven) {
    window.Raven.captureMessage('Translation Missing', {
      extra: {
        errorType: errorType,
        errorMessage: message,
        status: status,
        prefixKey: prefixKey,
        messageType: messageType,
        missingKeys: missingKeys
      }
    });
  }
};

var getComponentToRender = function getComponentToRender(key, options) {
  var hasHTML = /<("[^"]*"|'[^']*'|[^'">])*>/.test(_I18n.default.text(key, options));
  var ComponentToRender = hasHTML ? _FormattedHTMLMessage.default : _FormattedMessage.default;
  return _react.default.createElement(ComponentToRender, {
    message: key,
    options: options
  });
};

var getErrorKey = function getErrorKey(translationKeys) {
  return translationKeys.find(function (key) {
    return _I18n.default.lookup(key);
  });
};

var getErrorTypeLevelKeys = function getErrorTypeLevelKeys(prefixKey, errorType, action, messageType) {
  var keys = [];

  if (errorType) {
    if (action) {
      keys.push(prefixKey + "." + errorType + "." + action + "." + messageType);
    }

    keys.push(prefixKey + "." + errorType + ".default." + messageType);
  }

  return keys;
};

var getActionLevelKeys = function getActionLevelKeys(prefixKey, action, status, messageType) {
  var keys = [];

  if (action) {
    if (status) {
      keys.push(prefixKey + ".default-error." + action + "." + status + "." + messageType);
    }

    keys.push(prefixKey + ".default-error." + action + ".default." + messageType);
  }

  return keys;
};

var getDefaultLevelKeys = function getDefaultLevelKeys(prefixKey, status, messageType) {
  var keys = [prefixKey + ".default-error.default-action.default." + messageType];
  return status ? [prefixKey + ".default-error.default-action." + status + "." + messageType].concat(keys) : keys;
};

var getLibraryLevelKeys = function getLibraryLevelKeys(status, messageType) {
  var keys = ["ErrorMessaging.errors.default." + messageType];
  return status ? ["ErrorMessaging.errors." + status + "." + messageType].concat(keys) : keys;
};

var getTranslatedErrorText = function getTranslatedErrorText(data, messageType) {
  var logSentry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var action = data.action,
      _data$additionalTrans = data.additionalTranslationOptions,
      additionalTranslationOptions = _data$additionalTrans === void 0 ? {} : _data$additionalTrans,
      _data$count = data.count,
      count = _data$count === void 0 ? 1 : _data$count,
      prefixKey = data.prefixKey,
      _data$response = data.response,
      response = _data$response === void 0 ? {} : _data$response;
  var status = response.status,
      _response$responseJSO = response.responseJSON,
      responseJSON = _response$responseJSO === void 0 ? {} : _response$responseJSO;
  var errorType = responseJSON.errorType,
      _responseJSON$errorTo = responseJSON.errorTokens,
      errorTokens = _responseJSON$errorTo === void 0 ? {} : _responseJSON$errorTo,
      message = responseJSON.message;
  var options = (0, _extends2.default)({}, additionalTranslationOptions, errorTokens, {
    count: count
  });
  var missingKeys = [];
  var sentryData = {
    action: action,
    errorType: errorType,
    message: message,
    status: status,
    prefixKey: prefixKey,
    messageType: messageType
  };
  var translationKeys = getErrorTypeLevelKeys(prefixKey, errorType, action, messageType);
  var langKey = getErrorKey(translationKeys);

  if (!langKey) {
    missingKeys = [].concat((0, _toConsumableArray2.default)(missingKeys), (0, _toConsumableArray2.default)(translationKeys));
    translationKeys = getActionLevelKeys(prefixKey, action, status, messageType);
    langKey = getErrorKey(translationKeys);

    if (!langKey) {
      missingKeys = [].concat((0, _toConsumableArray2.default)(missingKeys), (0, _toConsumableArray2.default)(translationKeys));
      translationKeys = getDefaultLevelKeys(prefixKey, status, messageType);
      langKey = getErrorKey(translationKeys);

      if (!langKey) {
        missingKeys = [].concat((0, _toConsumableArray2.default)(missingKeys), (0, _toConsumableArray2.default)(translationKeys));
        translationKeys = getLibraryLevelKeys(status, messageType);
        langKey = getErrorKey(translationKeys);

        if (!langKey) {
          missingKeys = [].concat((0, _toConsumableArray2.default)(missingKeys), (0, _toConsumableArray2.default)(translationKeys));

          if (logSentry) {
            sentryLogger((0, _extends2.default)({}, sentryData, {
              missingKeys: missingKeys
            }));
          }

          return message;
        }
      }
    }
  }

  if (logSentry && missingKeys.length > 0) {
    sentryLogger((0, _extends2.default)({}, sentryData, {
      missingKeys: missingKeys
    }));
  }

  return getComponentToRender(langKey, options);
};

exports.getTranslatedErrorText = getTranslatedErrorText;

var getTranslatedErrorTitle = function getTranslatedErrorTitle(data, logSentry) {
  return getTranslatedErrorText(data, 'title', logSentry);
};

exports.getTranslatedErrorTitle = getTranslatedErrorTitle;

var getTranslatedErrorMessage = function getTranslatedErrorMessage(data, logSentry) {
  return getTranslatedErrorText(data, 'message', logSentry);
};

exports.getTranslatedErrorMessage = getTranslatedErrorMessage;

var configureGetErrorTitle = function configureGetErrorTitle(_ref) {
  var logSentry = _ref.logSentry;
  return function (data) {
    return getTranslatedErrorTitle(data, logSentry);
  };
};

exports.configureGetErrorTitle = configureGetErrorTitle;

var configureGetErrorMessage = function configureGetErrorMessage(_ref2) {
  var logSentry = _ref2.logSentry;
  return function (data) {
    return getTranslatedErrorMessage(data, logSentry);
  };
};

exports.configureGetErrorMessage = configureGetErrorMessage;